/**
 * Bouton d'installation de l'application.
 *
 * Ne s'affiche que lorsque le navigateur a réellement proposé l'installation : afficher
 * un bouton inopérant serait pire que de ne rien afficher. Sur iOS, où l'événement
 * `beforeinstallprompt` n'existe pas, le bouton reste donc invisible — l'installation
 * passe par « Partager → Sur l'écran d'accueil ».
 */

import { useT } from '../i18n/index.js';
import { promptInstall, useInstallStore } from '../pwa.js';

export function InstallButton(): React.JSX.Element | null {
  const available = useInstallStore((state) => state.deferredPrompt !== null);
  const installed = useInstallStore((state) => state.installed);
  const translator = useT();

  if (!available || installed) return null;

  return (
    <button type="button" className="btn btn-sm" onClick={() => void promptInstall()}>
      {translator.t('share.install')}
    </button>
  );
}
